import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React from "react"
import { Redirect } from "react-router"
import GlobalHelper from "../common/GlobalHelper"
import SideBar from "../common/layout/sidebar.component"
import LoadingSpinner from "../common/spinner/loading.component"
import MerchantOnboardingPage from "./merchant-onboarding/MerchantOnboardingPage"
import { useGetPaymentAccounts } from "./usePaymentAccountSession"
import { ACCOUNT_STATUS } from "../utils/account"

type Props = {
    redirectedFromSuccessfulSubmit?: boolean
}

const PaymentProcessingPage = (props: Props) => {

    SideBar.activateMenu("payment-processing")
    const { hasAccount, isLoading } = useGetPaymentAccounts()
    if (isLoading) {
        return <LoadingSpinner />
    }
    const hasAllowedCurrency = GlobalHelper.getCountryCodeFromCurrency(AppContext.getCurrency()) === "US"

    const canAccessPayments = (): boolean => {
        if (!hasAccount) {
            return false
        }

        if (props.redirectedFromSuccessfulSubmit) {
            return true
        }

        const paymentGatewayTestMode = AppContext.getAccount().attributes.paymentGatewayTestMode
        if (paymentGatewayTestMode) {
            return AppContext.getAccount().attributes.status == ACCOUNT_STATUS.DEMO
        }

        return true
    }

    const getLandingUrl = (): string => {
        if (props.redirectedFromSuccessfulSubmit) {
            return "/payment-processing/accounts"
        }

        return "/payment-processing/payments"
    }


    return (
        <>
            {!hasAllowedCurrency ? (
                <Redirect to={"/"} />
            ) : (
                canAccessPayments() ?
                    <Redirect to={getLandingUrl()} />
                    :
                    <MerchantOnboardingPage
                    />
            )}
        </>
    )
}

export default PaymentProcessingPage


// WEBPACK FOOTER //
// ./src/payment-processing/PaymentProcessingPage.tsx